import firebase from 'firebase'

export default {
  api_key: state => state.api_key,
  apps: state => state.apps,
  app_size: state => state.app_size,
  components: state => state.components,
  connection: state => state.connection,
  current_user: () => firebase.auth().currentUser,
  dark_theme: state => state.is_dark,
  error: state => state.error,
  log_messages: state => state.log_messages,
  notification: state => state.notification,
  req_errors: state => state.req_errors,
  req_state: state => state.req_state,
  saved_app_layout: state => state.saved_app_layout,
  saved_control_value: state => control_id =>
    state.saved_app_controls[control_id],
  user: state => state.user,
  user_abbr: state => state.user.username.split(' ')
    .map(s => {
      if(!s.length) return ''
      return s[0].toUpperCase()
    }).join(''),
  user_joined_str: state => {
    const dt = new Date(state.user.joined)
    const month = dt.toLocaleString('default', {month: 'short'})
    return `${month}. ${dt.getDate()}, ${dt.getFullYear()}`
  }
}
